import { hide, show } from "@intercom/messenger-js-sdk";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { Functionality } from "web/types/Employee";

import { useGetEmployeeDetailsQuery } from "web/features/employee/employeeApiSlice";

const IntercomTrigger = () => {
  const [isIntercomDisabledForRoute, setIsIntercomDisabledForRoute] =
    useState(false);
  const { data: employeeDetails } = useGetEmployeeDetailsQuery();
  const { functionalities } = employeeDetails || {};
  const location = useLocation();

  const isIntercomEnabled = functionalities?.includes(
    Functionality.ENABLE_INTERCOM
  );

  const handleClick = () => {
    if (window.isIntercomPanelVisibleToUser) {
      hide();
    } else {
      show();
    }
  };

  useEffect(() => {
    setIsIntercomDisabledForRoute(location.pathname.includes("checkout"));
  }, [location]);

  if (!isIntercomEnabled || isIntercomDisabledForRoute) {
    return null;
  }

  return (
    <IconButton
      sx={{
        width: "1.5rem",
        height: "1.5rem",
        borderRadius: "100%",
        backgroundColor: "#102b3f",
        color: "white",
      }}
      id="customIntercomLauncher"
      onClick={handleClick}
      size="small"
    >
      <QuestionMarkIcon sx={{ width: "1.25rem", height: "1.25rem" }} />
    </IconButton>
  );
};

export default IntercomTrigger;
